import React from 'react';
import { Box, Stack, Skeleton } from '@mui/material';

export const ChatSkeleton: React.FC = () => {
    return (
        <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            width: '100%',
            overflowY: 'auto', //  Разрешаем прокрутку сразу - фикс с залипанием прокрути списка сообщений
            WebkitOverflowScrolling: 'touch', //  Плавность для iOS
            bgcolor: '#5c7bb0', // наш фирменный синий
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='80' height='80' viewBox='0 0 80 80' xmlns='http://www.w3.org fill='%23ffffff' fill-opacity='0.15'%3E%3Ccircle cx='40' cy='40' r='2'/%3E%3C/g%3E%3C/svg%3E")`,
        }}>
            {/* Имитация Хедера */}
            <Box sx={{ p: 2, bgcolor: 'white', display: 'flex', alignItems: 'center', gap: 2, borderBottom: '1px solid #eee' }}>
                <Skeleton variant="circular" width={44} height={44} animation="wave" />
                <Box sx={{ flex: 1 }}>
                    <Skeleton variant="text" width="120px" height={24} animation="wave" />
                    <Skeleton variant="text" width="60px" height={16} animation="wave" />
                </Box>
            </Box>

            {/* Имитация Сообщений */}
            <Stack spacing={3} sx={{ p: 3, flex: 1, overflow: 'hidden' }}>
                {/* Входящее (слева) */}
                <Skeleton
                    variant="rounded"
                    width="70%"
                    height={85}
                    animation="wave"
                    sx={{ bgcolor: 'rgba(255,255,255,0.25)', borderRadius: '18px 18px 18px 0' }}
                />
                {/* Исходящее (справа) */}
                <Skeleton
                    variant="rounded"
                    width="50%"
                    height={65}
                    animation="wave"
                    sx={{ alignSelf: 'flex-end', bgcolor: 'rgba(255,255,255,0.35)', borderRadius: '18px 18px 0 18px' }}
                />
                {/* Входящее длинное */}
                <Skeleton
                    variant="rounded"
                    width="85%"
                    height={110}
                    animation="wave"
                    sx={{ bgcolor: 'rgba(255,255,255,0.25)', borderRadius: '18px 18px 18px 0' }}
                />
            </Stack>

            {/* Имитация Инпута */}
            <Box sx={{ p: 2, bgcolor: 'white', borderTop: '1px solid #eee' }}>
                <Skeleton variant="rounded" height={50} sx={{ borderRadius: '25px' }} animation="wave" />
            </Box>
        </Box>
    );
};
